import Api from "./Api";
import Api_2 from "./Api_extra";
import axios from "axios";
import { BASEURL } from "@/config/index";
import { createQueryString } from "./ApiHelper";

export default {
  GetJobOverHttpStatus(job_id) {
    return Api().get(`/jobs_over_http/check/${job_id}`);
  },
  GetSeatURLForQR(payload) {
    return Api().post(`/api/admin/screen_layouts/get-seat-qr`, payload);
  },
  VerifyMeritGirftCard(payload) {
    return Api().get(`/api/pos/merit_gc/get_balance/${payload.card_number}`);
  },
  PayByMeritGiftCard(payload) {
    return Api().post(`/api/pos/merit_gc/payment`, payload);
  },
  CancelMeritGCTransaction(payload) {
    return Api().post(`/api/pos/merit_gc/payment_cancel`, payload);
  },
  AddEarnPoints(payload) {
    return Api().post("/earn_points", payload);
  },
  BurnPoints(payload) {
    return Api().post("/burn_points", payload);
  },
  GetCinemaList(payload) {
    let cinema_id = payload.cinema_id ? payload.cinema_id : "";
    return Api().get(
      "/api/admin/cinemas_list?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&cinema_id=" +
        cinema_id +
        "&searchKey=" +
        payload.searchKey +
        "&searchValue=" +
        payload.searchValue +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy
    );
  },
  GetCinemasMovieLicence() {
    return Api().get("/api/admin/cinema-list-movie-licence");
  },
  GetMacsLog() {
    return Api().get("/api/admin/getMacsLogs");
  },
  getMailLogs() {
    return Api().get("/api/admin/autoemailreport-v2-logs");
  },
  GetGCAMLog() {
    return Api().get("/api/admin/getGCAMLogs");
  },
  GetCinemaSettingList() {
    return Api().get("/api/admin/cinemas_setting_list");
  },
  AddFeedbackForm(payload) {
    return Api().post("/api/feedbackforms/addfeedbackform", payload);
  },
  GetAllForms(payload) {
    return Api().post(
      "/api/feedbackforms/fetchforms?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy +
        "&searchValue=" +
        payload.searchValue
    );
  },
  GetFormData(payload) {
    return Api().post("/api/feedbackforms/getformdata", payload);
  },
  GetInputFormData(payload) {
    return Api().post("/api/feedbackforms/getinputformdata", payload);
  },
  InsertFormInput(payload) {
    return Api().post("/api/feedbackforms/insertforminput", payload);
  },
  CustomerFormInput(payload) {
    return Api().post("/api/feedbackforms/customerforminput", payload);
  },
  InsertValue(payload) {
    return Api().post("api/end/point", payload);
  },
  DeleteValue(payload) {
    return Api().post("api/end/point", payload);
  },
  UpdateValue(payload) {
    return Api().post("api/end/point", payload);
  },
  getCinemaList(payload) {
    return Api().get("ms_cinemas", payload);
  },
  getScreenList(payload) {
    return Api().get("screens", payload);
  },
  addScreenLayout(payload) {
    return Api().post("/screen_layouts", payload);
  },
  getSeatType(payload) {
    return Api().get("ms_seat_reserve_types", payload);
  },
  getScreenSeatType(payload) {
    return Api().get("ms_seat_reserve_types", payload);
  },
  getMovieList(payload) {
    return Api().get("movie/movielist", payload);
  },
  getSeatLayout(payload) {
    return Api().get("/screen_layouts/" + payload.screenID, payload);
  },
  getDays(payload) {
    return Api().get("ms_week_days", payload);
  },
  getCustomFields(payload) {
    return Api().post("/api/admin/getcustomfields", payload);
  },
  getCustomFieldValue(payload) {
    return Api().post("/api/admin/getcustomfieldvalue", payload);
  },
  AddCustomFields(payload) {
    return Api().post("/api/admin/addcustomfields", payload);
  },
  // AddSeo(payload) {
  //   return Api().post('/api/admin/seo', payload)
  // },
  // GetSeoList() {
  //   return Api().get('/api/admin/seo')
  // },
  // GetSeo(payload) {
  //   return Api().get(`/api/admin/seo?seo_meta_id=${payload.seo_meta_id}`)
  // },
  // EditSeo(payload) {
  //   return Api().put('/api/admin/seo', payload)
  // },
  EditGlobalPrivateOptions(payload) {
    return Api().post("/global_options/update_private_global_options", payload);
  },
  GetGlobalPrivateOptions(payload) {
    return Api().get("/global_options/private_global_options");
  },
  EditGlobalOptions(payload) {
    return Api().put("/api/admin/globaloptions", payload);
  },

  GetPrivateGlobalOptions(payload) {
    return Api().get("/api/admin/globaloptions_private");
  },

  EditPrivateGlobalOptions(payload) {
    return Api().put("/api/admin/globaloptions_private", payload);
  },

  //cinema type
  AddCinemaType(payload) {
    return Api().post("/api/admin/cinematype", payload);
  },
  GetCinemaTypesList(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/cinematype${query}`);
  },
  GetCinemaTypeData(payload) {
    return Api().get(
      `/api/admin/cinematype?cinema_type_id=${payload.cinema_type_id}`
    );
  },
  EditCinemaType(payload) {
    return Api().put("/api/admin/cinematype", payload);
  },

  //tier type
  GetTierTypeList() {
    return Api().get("/api/admin/tiertype");
  },
  AddTierType(payload) {
    return Api().post("/api/admin/tiertype", payload);
  },
  GetTierTypeData(payload) {
    return Api().get(
      `/api/admin/tiertype?tier_type_id=${payload.tier_type_id}`
    );
  },
  EditTierType(payload) {
    return Api().put("/api/admin/tiertype", payload);
  },

  GlobalRequest(body) {
    switch (body.method) {
      case "GET":
        return Api().get(`${body.url}`);
        break;
      case "POST":
        return Api().post(`${body.url}`, body.payload);
        break;
      case "PUT":
        return Api().put(`${body.url}`, body.payload);
        break;
      case "DELETE":
        return Api().delete(`${body.url}`, body.payload);
        break;
      default:
        break;
    }
  },
  GlobalUploadImage(payload, options) {
    // return Api().post('uploadimage',payload)
    let JWT = window.localStorage.getItem("JWT_TOKEN");
    let opts = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: JWT,
        "Access-Control-Allow-Origin": "*",
      },
    };
    if (options) {
      opts = {
        ...opts,
        ...options,
      };
    }

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASEURL}/uploadimage`, payload, opts)
        .then((res) => resolve(res))
        .catch((error) => {
          console.log("UPLOAD IMAGE ERROR", error.message, error);

          reject(error);
        });
    });
  },

  SetupUploadImage(payload) {
    let AUTH_KEY = window.localStorage.getItem("AUTH_KEY");

    const configHeaders = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: AUTH_KEY,
      },
    };

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASEURL}/setupOrg/uploadimage`, payload, configHeaders)
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
        });
    });
  },

  GlobalUploadVideo(payload, options) {
    if (!options) {
      options = {
        headers: {
          "content-type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
        },
      };
    }

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASEURL}/uploadvideo`, payload, options)
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
        });
    });
  },

  GlobalUploadFile(payload) {
    const configHeaders = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASEURL}/uploadfile`, payload, configHeaders)
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
        });
    });
  },

  GlobalUploadAllTypeFile(payload) {
    const configHeaders = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };

    return new Promise((resolve, reject) => {
      axios
        .post(`${BASEURL}/uploadfileContactUs`, payload, configHeaders)
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
        });
    });
  },

  GetGlobalOptions(payload) {
    if (payload) {
      const query = createQueryString(payload);
      return Api().get(`/global_options${query}`);
    } else {
      return Api().get(`/global_options`);
    }
  },
  GetHealthMeta() {
    return Api().get(`/health-meta`);
  },
  // GetActiveListByConditionalId(payload) {
  //   return Api().get(`/api/admin/tablelist/${payload.tableName}?activekey=${payload.activekey}&condition_col_name=${payload.condition_col_name}&condition_id=${payload.condition_id}`)
  // },
  GetActiveList(payload) {
    let query = "";
    let length = Object.keys(payload).length;
    if (length > 0) {
      query = "?";
      Object.keys(payload).map((x, index) => {
        if (x !== "tableName") {
          query +=
            index === length - 1 ? `${x}=${payload[x]}` : `${x}=${payload[x]}&`;
        }
      });
    }
    return Api_2().get(`/api/admin/tablelist/${payload.tableName}${query}`);
  },

  // Ticket Type routes

  AddTicketTicketType(payload) {
    return Api().post(`/api/admin/ms_ticket_type`, payload);
  },
  EditTicketTicketType(payload) {
    return Api().put(`/api/admin/ms_ticket_type`, payload);
  },
  ViewTicketTicketType(payload) {
    return Api().get(
      `/api/admin/ms_ticket_type?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&filter_is_active=${payload.filter_is_active}`
    );
  },
  GetTicketTicketTypeById(payload) {
    return Api().get(`/api/admin/ms_ticket_type?id=${payload.tt_id}`);
  },
  //Regions
  AddRegion(payload) {
    return Api().post(`/api/admin/ms_regions`, payload);
  },
  EditRegion(payload) {
    return Api().put(`/api/admin/ms_regions`, payload);
  },
  ListRegion(payload) {
    return Api().get(
      `/api/admin/ms_regions?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}&region_is_active=${payload.region_is_active}`
    );
  },
  GetRegionById(payload) {
    return Api().get(`/api/admin/ms_regions?id=${payload.region_id}`);
  },

  /**
   * Denominations
   */
  AddDenomination(payload) {
    return Api().post(`/api/admin/denominations`, payload);
  },
  // GetDenomination(country_id, payload) {
  //   return Api().get(
  //     `/api/admin/denominations?country_id=${country_id}&limit=${payload.limit}&currentPage=${payload.currentPage}&orderBy=${payload.orderBy}&columnName=${payload.columnName}`
  //   );
  // },
  GetDenomination(country_id, payload) {
    const { limit, currentPage, orderBy, columnName, is_active } = payload;

    // Construct the query string
    const query =
      `/api/admin/denominations?country_id=${country_id}&limit=${limit}&currentPage=${currentPage}&orderBy=${orderBy}&columnName=${columnName}` +
      (is_active !== undefined ? `&is_active=${is_active}` : "");

    return Api().get(query);
  },
  GetDenominationById(payload) {
    return Api().get(`/api/admin/denominations/${payload.denomination_id}`);
  },
  UpdateDenomination(payload) {
    return Api().put(
      `/api/admin/denominations/${payload.denomination_id}`,
      payload
    );
  },
  /**
   * Denominations End
   */
  /**
   *  Shift
   */
  GetUserShiftsByUserId(payload) {
    return Api().get(`/api/admin/usershiftsbyuserid/${payload.user_id}`);
  },
  GetRdrPdfReport(payload) {
    return Api().post(`/api/admin/get-revenue-drop-pdf`, payload);
  },
  GetRdrExcelReport(payload) {
    return Api().post(`/api/admin/get-revenue-drop-excel`, payload);
  },

  /**
   *  ShiftEnd
   */

  GetAllUserShifts(payload) {
    return Api().get(`/user_shifts`, { params: payload });
  },
  AddUserShifts(payload) {
    return Api().post(`/user_shifts`, payload);
  },
  GetUserShiftDetails(payload) {
    return Api().get(`/user_shifts/${payload.us_id}`);
  },
  GetAllUserShiftsDates() {
    return Api().get(`/get_user_shifts_dates`);
  },
  UpdateUserShifts(payload) {
    return Api().put(`/user_shifts`, payload);
  },

  /**
   *  User Info
   */

  GetUserInfoById(payload) {
    return Api().get(`/api/admin/userinfo/${payload.user_id}`);
  },

  /**
   *  User Info End
   */

  // DELETE, May be extra
  GetData(payload) {
    console.log("payload :", payload);
    // Delete
    // return Api().delete(`/api/users/${payload.ID}`)
    // POST
    // return Api().post('/api/users', payload)
    // return Api().put('/api/users', payload)
    // GET
    return Api().get("/api/users:", payload);
    // params
    // return Api().get(`/api/users/${payload.ID}`)
    // Query
    // return Api().get(`/api/users?${payload.ID}`)
  },
  AddUnitOfMeasurement(payload) {
    return Api().post("/ms_unit_of_measurement", payload);
  },
  editUnitOfMeasurementOperation(payload) {
    return Api().put(`/ms_unit_of_measurement/${payload.uom_id}`, payload);
  },

  GetUoMTList(payload) {
    return Api().post(`/get_conversion_to_list`, payload);
  },

  GlobalRemoveFile(payload) {
    return Api().post(`/api/admin/removereportfile`, payload);
  },

  GenerateAggToken(payload) {
    return Api().get(`/api/admin/generate_aggregator_token/${payload.user_id}`);
  },

  RemoveDownloadedFile(payload) {
    return Api().post(`/api/admin/removeMultipleReportfile`, payload);
  },

  generateTimLogs(payload) {
    return Api().post(`/api/admin/generateTimLogs`, payload);
  },

  AddScreens(payload) {
    return Api().post(`/api/admin/screens`, payload);
  },
  GetScreens(payload) {
    return Api().get(`/api/admin/screens?s_id=${payload.s_id}`);
  },

  EditScreens(payload) {
    return Api().put(`/api/admin/screens`, payload);
  },

  GetScreenTypes(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().get(
        `/api/admin/screentypes?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    } else {
      return Api().get(`/api/admin/screentypes`);
    }
  },
  GetSingleScreenType(payload) {
    return Api().get(`/api/admin/screentypes/${payload.screen_type_id}`);
  },
  AddScreenTypes(payload) {
    return Api().post(`/api/admin/screentypes`, payload);
  },
  UpdateScreenTypes(payload) {
    return Api().put(
      `/api/admin/screentypes/${payload.screen_type_id}`,
      payload
    );
  },
  GetScreenSizeFormat(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().get(
        `/api/admin/screensizeformat?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    } else {
      return Api().get(`/api/admin/screensizeformat`);
    }
  },
  GetSingleScreenSizeFormat(payload) {
    return Api().get(`/api/admin/screensizeformat/${payload.ssf_id}`);
  },
  AddScreenSizeFormat(payload) {
    return Api().post(`/api/admin/screensizeformat`, payload);
  },
  UpdateScreenSizeFormat(payload) {
    return Api().put(`/api/admin/screensizeformat/${payload.ssf_id}`, payload);
  },

  AddWeekends(payload) {
    return Api().post(`/api/admin/weekends`, payload);
  },

  GetWeekendsList(cinema_id) {
    return Api().get(`/api/admin/weekends?cinema_id=${cinema_id}`);
  },

  EditWeekends(payload) {
    return Api().put(`/api/admin/weekends`, payload);
  },

  // VERIFY DOCUMENTS API'S
  // BANK API'S
  getAllVerificationDocument(perPage, currentPage, columnName, orderby) {
    return Api().get(
      `/api/admin/viewverificationdocuments?limit=${perPage}&currentPage=${currentPage}&columnName=${columnName}&orderBy=${orderby}`
    );
  },
  getVerificationDocumentDetails(payload) {
    return Api().get(`/api/admin/viewsingledocument/${payload.vd_id}`);
  },
  addVerificationDocument(payload) {
    return Api().post("/api/admin/addverificationdocument", payload);
  },
  editVerificationDocument(payload) {
    return Api().put(
      `/api/admin/updateverificationdocumnet/${payload.vd_id}`,
      payload
    );
  },

  //Cinema Ticket Templates
  AddCinemaTicketTemplate(payload) {
    return Api().post(`/api/admin/cinematickettemplate`, payload);
  },
  GetCinemaTicketTemplate(body) {
    if (
      body &&
      body.hasOwnProperty("limit") &&
      body.hasOwnProperty("currentPage")
    ) {
      let cinema_id =
        body.cinema_id && body.cinema_id.toString().length > 0
          ? body.cinema_id
          : "";

      return Api().get(
        `/api/admin/cinematickettemplate?limit=${body.limit}&currentPage=${body.currentPage}&cinema_id=${cinema_id}&columnName=${body.columnName}&orderBy=${body.orderBy}`
      );
    } else {
      return Api().get(`/api/admin/cinematickettemplate?tt_id=${body.temp_id}`);
    }
  },
  EditCinemaTicketTemplate(payload) {
    return Api().put(`/api/admin/cinematickettemplate`, payload);
  },

  //Ticket Templates
  GetTicketTemplate(body) {
    if (
      body &&
      body.hasOwnProperty("limit") &&
      body.hasOwnProperty("currentPage") &&
      !body.hasOwnProperty("columnName") &&
      !body.hasOwnProperty("orderBy")
    ) {
      return Api().get(
        `/api/admin/tickettemplate?limit=${body.limit}&currentPage=${body.currentPage}`
      );
    } else if (
      body &&
      body.hasOwnProperty("limit") &&
      body.hasOwnProperty("currentPage") &&
      body.hasOwnProperty("columnName") &&
      body.hasOwnProperty("orderBy")
    ) {
      return Api().get(
        `/api/admin/tickettemplate?limit=${body.limit}&currentPage=${body.currentPage}&columnName=${body.columnName}&orderBy=${body.orderBy}`
      );
    } else {
      return Api().get(
        `/api/admin/tickettemplate?t_id=${body.temp_id}&flag=${body.flag}`
      );
    }
  },
  AddTicketTemplate(payload) {
    return Api().post(`/api/admin/tickettemplate`, payload);
  },
  EditTicketTemplate(payload) {
    return Api().put(`/api/admin/tickettemplate`, payload);
  },

  //Get Cinema Ticket Template for POS Ticket by CinemaID
  TicketTemplateByCinemaID(payload) {
    return Api().get(
      `/api/admin/ticket_template_by_cinemaID?cine_id=${payload.cine_id}`
    );
  },

  ReleaseSeat(payload) {
    return Api().put(`/api/admin/releaseseat`, payload);
  },
  GetActiveUsersAccordingRolesList(payload) {
    return Api().post(`/api/admin/getactiveusersaccordingroles`, payload);
  },
  /**
   * Aggregators
   */
  AddAggregator(payload) {
    return Api().post(`/api/admin/add-aggregator`, payload);
  },
  UpdateAggregator(payload) {
    return Api().put(
      `/api/admin/update-aggregator/${payload.aggregator_id}`,
      payload
    );
  },
  /**
   * Aggregators END
   */
  /**
   * Shift Close
   */
  OnGetSingleShiftClose(payload) {
    return Api().get(`/api/admin/get-shift-close-details/${payload.shift_id}`);
  },
  OnShiftClose(payload) {
    return Api().put(
      `/api/admin/shift-close-update/${payload.usl_id}`,
      payload
    );
  },
  OnUpdateShiftClose(payload) {
    return Api().post(
      `/api/admin/shift-close-update/${payload.usl_id}`,
      payload
    );
  },
  updateTLStatus(payload) {
    return Api().put(`/api/admin/update-tl-close-shift`, payload);
  },
  OnGetSingleViewShiftClose(payload) {
    return Api().get(
      `/api/admin/get-shift-close-view-details/${payload.shift_id}`
    );
  },
  /**
   * Shift Close
   */

  // Aggregator Movie Access Rights
  GetMovieBasedSchedule(payload) {
    return Api().post(
      `/api/admin/get-movies-based-schedule?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetPosAggregatorUsers() {
    return Api().get(`/api/admin/get-pos-aggegator-users`);
  },
  SetAccessScheduleMapping(payload) {
    return Api().post(`/api/admin/set-access-schedule-mapping`, payload);
  },
  GetAllShowDates() {
    return Api().get(`/api/admin/get-all-show-dates`);
  },

  // Aggregator Movie Access Rights
  GetFnbBasedItems(payload) {
    return Api().post(
      `/api/admin/get-fnb-based-items?limit=${payload.limit}&currentPage=${payload.currentPage}`,
      payload
    );
  },
  GetFnBPosAggregatorUsers() {
    return Api().get(`/api/admin/get-fnb-based-items`);
  },
  SetAccessFnBMapping(payload) {
    return Api().post(`/api/admin/set-access-fnb-mapping`, payload);
  },
  GetAllToDates() {
    return Api().get(`/api/admin/get-all-fnb-to-dates`);
  },

  GetDistributors() {
    return Api().get(`/ms_distributors`);
  },

  //user shift logs for audit logs
  getUserShiftLogsByDetail(payload) {
    console.log("payload :", payload);
    return Api().post(`/api/admin/posusershiftlogsdetails`, payload);
  },
  getLogs(payload) {
    return Api().post(
      `/api/admin/getlogdetails?limit=${payload.perPage}&currentPage=${payload.currentPage}`,
      payload
    );
  },

  getTransactionsByDetail(payload) {
    // console.log("payload :", payload);
    return Api_2().post(`/api/admin/posusertransactions`, payload);
  },
  getReservationsDetail(payload) {
    return Api_2().post(`/api/admin/reservation-log`, payload);
  },
  getReservationsDetailTemp(payload) {
    return Api().post(`/api/admin/reservation-log-temp`, payload);
  },
  getReservationsDetailV2(payload) {
    return Api_2().post(`/api/admin/reservation-log-v2`, payload);
  },
  getPaymentFlowLogs(reservation_id) {
    return Api().get(`/api/admin/get-payment-flow-logs/${reservation_id}`);
  },
  getReportBuilderDetail(payload) {
    let qs = createQueryString(payload);

    console.log({ qs });
    console.log({ payload });

    return Api().get(`/api/admin/v2/dynamic-report/${qs}`);
  },
  getScheduleMovieSortOrder(payload) {
    let qs = createQueryString(payload);

    return Api().get(`/api/admin/get-schedule-movie-sort-order/${qs}`);
  },
  getUpcomingMovieSortOrder(payload) {
    let qs = createQueryString(payload);

    return Api().get(`/api/admin/get-upcoming-movie-sort-order/${qs}`);
  },
  insertScheduleMovieSortOrder(payload) {
    return Api().post(`/api/admin/insert-schedule-movie-sort-order`, payload);
  },
  insertUpcomingMovieSortOrder(payload) {
    return Api().post(`/api/admin/insert-upcoming-movie-sort-order`, payload);
  },
  getAggregatorReport(payload) {
    let qs = createQueryString(payload);

    console.log({ qs });
    console.log({ payload });

    return Api().get(`/api/admin/v2/aggregatorReport${qs}`);
  },
  getAggregatorReportExcel(payload) {
    return Api().post(`/api/admin/v2/aggregatorReportExcel`, payload);
  },
  getAggregatorReportExcelWithComplimentary(payload) {
    return Api().post(
      `/api/admin/v2/aggregatorReportExcelWithComplimentary`,
      payload
    );
  },
  getAggregatorReportPdf(payload) {
    return Api().post(`/api/admin/v2/aggregatorReportPdf`, payload);
  },
  getAggregatorReportPdfWithComplimentary(payload) {
    return Api().post(
      `/api/admin/v2/aggregatorReportPdfWithComplimentary`,
      payload
    );
  },
  getReportBuilderFnBDetail(payload) {
    let qs = createQueryString(payload);

    console.log({ qs });
    console.log({ payload });

    return Api_2().get(`/api/admin/v2/dynamic-report-fnb/${qs}`);
  },
  saveReportPreset(payload) {
    return Api().post(`/api/admin/v2/dynamic-report/save-preset`, payload);
  },
  saveReportPresetWithChecker(payload) {
    return Api_2().post(`/api/admin/v2/dynamic-report/save-preset-v2`, payload);
  },
  saveReportPresetV3(payload) {
    return Api().post(
      `/api/admin/v2/dynamic-report/get-save-preset-v3`,
      payload
    );
  },
  updateReportPreset(rp_id, payload) {
    return Api_2().post(
      `/api/admin/v2/dynamic-report/update-preset/${rp_id}`,
      payload
    );
  },
  getCustomerDetails(payload) {
    return Api().post(
      `/api/admin/getcustomerdetails?limit=${payload.perPage}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`,
      payload
    );
  },
  getCustomerTransactions(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().post(
        `/api/admin/getcustomertransactiondetails?limit=${payload.limit}&currentPage=${payload.currentPage}`,
        payload
      );
    } else {
      return Api().post(`/api/admin/getcustomertransactiondetails`, payload);
    }
  },
  getGuestCustomerTransactions(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().post(
        `/api/admin/getGuestCustomerTransactiondetails?limit=${payload.limit}&currentPage=${payload.currentPage}`,
        payload
      );
    } else {
      return Api().post(`/api/admin/getcustomertransactiondetails`, payload);
    }
  },

  GetActiveUsers(payload) {
    return Api().post("/active-list/users", payload);
  },
  GetActiveReportList(payload) {
    return Api().post("/active-list/report_list", payload);
  },
  AddAutoEmailReport(payload) {
    return Api().post("/api/admin/autoemailreport", payload);
  },
  AddAutoEmailReportV2(payload) {
    return Api().post("/api/admin/autoemailreport-v2", payload);
  },
  GetAutoEmailReport(payload) {
    return Api().get(`/api/admin/autoemailreport`, { params: payload });
  },
  GetAutoEmailReportV2(payload) {
    return Api().get(`/api/admin/autoemailreport-v2`, { params: payload });
  },
  DisableAllAutoEmailReportV2(payload = {}) {
    return Api().get(`/api/admin/autoemailreport-v2-disable-all`, payload);
  },
  GetSingleAutoEmailReport(payload) {
    return Api().get(`/api/admin/autoemailreport?aec_id=${payload.aec_id}`);
  },
  EditAutoEmailReport(payload) {
    return Api().put("/api/admin/autoemailreport", payload);
  },

  //EmailTemplate
  AddEmailTemplate(payload) {
    return Api().post("/api/admin/emailtemplate", payload);
  },
  GetEmailTemplate(payload) {
    return Api().get(
      `/api/admin/emailtemplate?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
    );
  },
  GetSingleEmailTemplate(payload) {
    return Api().get(`/api/admin/emailtemplate?et_id=${payload.et_id}`);
  },
  EditEmailTemplate(payload) {
    return Api().put("/api/admin/emailtemplate", payload);
  },

  //SMSTemplate
  AddSMSTemplate(payload) {
    return Api().post("/api/admin/smstemplate", payload);
  },
  GetSMSTemplate(payload) {
    return Api().get(
      `/api/admin/smstemplate?limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  GetSingleSMSTemplate(payload) {
    return Api().get(`/api/admin/smstemplate?sms_id=${payload.sms_id}`);
  },
  EditSMSTemplate(payload) {
    return Api().put("/api/admin/smstemplate", payload);
  },

  //Send EMail
  Sendemail(payload) {
    return Api().post("/api/admin/sendemail", payload);
  },

  //Send SMS
  Sendsms(payload) {
    return Api().post("/api/admin/sendsms", payload);
  },

  //ReceiptTemplate
  AddReceiptTemplate(payload) {
    return Api().post(`/api/admin/receipttemplate`, payload);
  },
  GetReceiptTemplate(payload) {
    if (
      payload &&
      payload.hasOwnProperty("columnName") &&
      payload.hasOwnProperty("orderBy")
    ) {
      return Api().get(
        `/api/admin/receipttemplate?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    } else {
      return Api().get(
        `/api/admin/receipttemplate?limit=${payload.limit}&currentPage=${payload.currentPage}`
      );
    }
  },
  GetSingleReceiptTemplate(payload) {
    return Api().get(
      `/api/admin/GetSinglereceipttemplate?rtemp_id=${payload.rtemp_id}&flag=${payload.flag}`
    );
  },
  UpdateReceiptTemplate(payload) {
    return Api().put(`/api/admin/receipttemplate`, payload);
  },

  //BannerService
  AddBanner(payload) {
    return Api().post("/api/admin/addbanner", payload);
  },
  EditBanner(payload) {
    return Api().put("/api/admin/editbanner", payload);
  },
  GetAllBanners(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/getbanners${query}`);
  },
  UpdateBannerStatus(payload) {
    // const query = createQueryString(payload);
    return Api().post(`/api/admin/banner-status/${payload.unique_id}`, payload);
  },
  GetMasterBanners(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/getmasterbanners${query}`);
  },
  GetSingleBanner(payload) {
    return Api().get(`/api/admin/getSinglebanners?b_id=${payload.b_id}`);
  },
  UpdateBannerOrder(payload) {
    return Api().put(`/api/admin/editBannerOrder`, payload);
  },
  GetBannerTypes() {
    return Api().get(`/api/admin/bannertypes`);
  },

  //Support Ticket Category
  AddCategory(payload) {
    return Api().post("/api/admin/SupportTicketCategory", payload);
  },
  GetCategory(payload) {
    if (
      payload &&
      payload.hasOwnProperty("limit") &&
      payload.hasOwnProperty("currentPage")
    ) {
      return Api().get(
        `/api/admin/SupportTicketCategory?limit=${payload.limit}&currentPage=${payload.currentPage}`
      );
    } else {
      return Api().get(
        `/api/admin/SupportTicketCategory?stc_id=${payload.stc_id}`
      );
    }
  },
  UpdateCategory(payload) {
    return Api().put("/api/admin/SupportTicketCategory", payload);
  },
  GenericSearch(payload) {
    return Api().post("/api/admin/generic/search", payload);
  },

  //Sound Format
  AddSoundFormat(payload) {
    return Api().post("/api/admin/soundformat", payload);
  },
  GetSoundFormatList(payload) {
    return Api().get(
      "/api/admin/soundformat?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy +
        "&searchValue=" +
        payload.searchValue +
        "&filter_is_active=" +
        payload.filter_is_active
    );
  },
  EditSoundFormat(payload) {
    return Api().put("/api/admin/soundformat", payload);
  },
  GetSoundFormat(payload) {
    return Api().post(`/api/admin/getsoundformat/${payload.sound_format_id}`);
  },
  GetCinemas(payload = {}) {
    payload.cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api().post(`/api/admin/getcinemas`, payload);
  },
  GetCinemasByRoles(payload = {}) {
    payload.cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api().post(`/api/admin/getcinemasbyRoles`, payload);
  },
    GetCinemasByRolesUrl(payload = {}) {
    payload.cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api().post(`/api/admin/getcinemasbyRolesUrl`, payload);
  },
  RejectToCinemaStockTransfer(tsl_id) {
    return Api().post(`/transfer_stock/reject/${tsl_id}`);
  },
  RejectToCinemaStockTransferByPo(po_id) {
    return Api().post(`/transfer_stock/reject/po/${po_id}`);
  },
  //Get Store Management
  GetStoreManagement(payload) {
    console.log("payload.cine_id:::::::::: :>> ", payload.cine_id);
    let cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    let sm_parent_id =
      payload.sm_parent_id && payload.sm_parent_id.toString().length > 0
        ? payload.sm_parent_id
        : "";
    if (sm_parent_id.length == 0 && payload.sm_parent_id == 0) sm_parent_id = 0;
    console.log("cine_id :>> ", cine_id);
    return Api().get(
      `/api/admin/getstoremanagement?cine_id=${cine_id}&sm_parent_id=${sm_parent_id}`
    );
  },
  GetUsers(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/getusers${qs}`);
  },
  GetConcessionByCinema(payload) {
    let cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    console.log("cine_id :>> ", cine_id);
    return Api().get(`/api/admin/getconcessionbycinema?cine_id=${cine_id}`);
  },
  /**
   * Addons
   */
  CreateAddon(payload) {
    return Api().post("/api/admin/add_ons", payload);
  },
  UpdateAddons(payload) {
    return Api().put("/api/admin/add_ons", payload);
  },
  GetSingleAddonDetails(payload) {
    return Api().get("/api/admin/single_add_on/" + payload.add_on_id);
  },
  GetSingleAddonCharges(payload) {
    return Api().get("/api/admin/single_add_on_charges/" + payload.add_on_id);
  },
  GetAllAddonsList() {
    return Api().get("/api/admin/add_ons");
  },
  //get all images from gallery
  GetGalleryImages(payload) {
    return Api().post(`/api/image-gallery`, payload);
    // return Api().post(`/api/image-gallery?searchValue=${payload.searchValue}&menu=${payload.menu}&category=${payload.category}&limit=${payload.limit}&currentPage=${payload.currentPage}`)
    // ?limit=${payload.limit}&currentPage=${payload.currentPage
  },

  //booking source payment mapping
  AddBsPaymentMapping(payload) {
    return Api().post("/api/admin/bs_payment_mapping", payload);
  },
  EditBsPaymentMapping(payload) {
    return Api().put("/api/admin/bs_payment_mapping", payload);
  },
  UpdateImageDetails(payload) {
    return Api().post(`/api/image-gallery/${payload.image_id}`, payload);
  },
  GetImageDetails(image_id) {
    return Api().put(`/api/image-gallery/${image_id}`);
  },
  DisableImage(image_id) {
    return Api().delete(`/api/image-gallery/${image_id}`);
  },
  getMultipleCinemasData(payload) {
    return Api().post(`/api/admin/getMultipleCinemasDetails`, payload);
  },
  //Delete Designation
  DeleteDesignationById(payload) {
    return Api().delete(`/ms_designations/${payload.id}`);
  },

  updateRating(payload) {
    return Api().post("/api/admin/updateRating", payload);
  },
  GetComments(payload) {
    return Api().get(
      `/api/admin/comments?limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&searchValue=${payload.searchValue}`
    );
  },
  UpdateComment(payload) {
    return Api().put(`/api/admin/comments/${payload.c_id}`, payload);
  },
  AddComment(payload) {
    return Api().post(`/api/admin/comments`, payload);
  },
  GetSingleComment(payload) {
    return Api().get(`/api/admin/comments/${payload.c_id}`);
  },

  /* aspect Ratio */
  GetAllAspectRatios(payload = {}) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/aspectratio/${qs}`);
  },
  GetAspectRatio(aspect_ratio_id) {
    if (!aspect_ratio_id) return Promise.reject();
    return Api().get(`/api/admin/aspectratio/${aspect_ratio_id}`);
  },
  AddAspectRatio(payload) {
    return Api().post(`/api/admin/aspectratio/`, payload);
  },
  UpdateAspectRatio(payload) {
    if (!payload.aspect_ratio_id) return Promise.reject();
    return Api().put(
      `/api/admin/aspectratio/${payload.aspect_ratio_id}`,
      payload
    );
  },

  /* Movie Resolutions */
  GetAllMovieResolutions(payload = {}) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/movie-resolution/${qs}`);
  },
  GetMovieResolution(resolution_id) {
    if (!resolution_id) return Promise.reject();
    return Api().get(`/api/admin/movie-resolution/${resolution_id}`);
  },
  AddMovieResolution(payload) {
    return Api().post(`/api/admin/movie-resolution/`, payload);
  },
  UpdateMovieResolution(payload) {
    if (!payload.resolution_id) return Promise.reject();
    return Api().put(
      `/api/admin/movie-resolution/${payload.resolution_id}`,
      payload
    );
  },

  /* Movie Experience Format */
  GetAllMovieExperienceFormats(payload = {}) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/experience-format/${qs}`);
  },
  GetMovieExperienceFormat(movie_experience_id) {
    if (!movie_experience_id) return Promise.reject();
    return Api().get(`/api/admin/experience-format/${movie_experience_id}`);
  },
  AddMovieExperienceFormat(payload) {
    return Api().post(`/api/admin/experience-format/`, payload);
  },
  UpdateMovieExperienceFormat(payload) {
    if (!payload.movie_experience_id) return Promise.reject();
    return Api().put(
      `/api/admin/experience-format/${payload.movie_experience_id}`,
      payload
    );
  },

  GetAllTranslations(payload) {
    return Api().get(
      `/api/admin/translations?perPage=${payload.perPage}&currentPage=${
        payload.currentPage
      }&search=${payload.search ? payload.search : ""}&columnName=${
        payload.columnName ? payload.columnName : ""
      }&orderBy=${payload.orderBy ? payload.orderBy : ""}&translation_id=${
        payload.translation_id ? payload.translation_id : ""
      }`
    );
  },
  UpdateTranslation(payload) {
    return Api().patch(
      `/api/admin/edit-translation/${payload.translation_id}`,
      payload
    );
  },
  GetPaymentModes(payload = {}) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/payment-modes/${query}`);
  },
  GetWeekWisePdf(payload) {
    return Api().post(`/api/admin/reports/v2/daily`, payload);
  },
  GetOrgDetails() {
    return Api().get(`/api/admin/getOrgDetails`);
  },
  hotPickModule(payload) {
    return Api().post(`/api/admin/hot-picks/${payload.module_id}`);
  },
  getHotPickModules() {
    return Api().get(`/api/admin/hot-picks`);
  },
  getAllLabels(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/ms_movie_labels${query}`);
  },
  getAllReferralCode(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/marketing/referral_code${query}`);
  },
  getAllFnbLabels(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/ms_fnb_labels${query}`);
  },
  AddLabel(payload) {
    return Api().post(`/api/admin/ms_movie_labels`, payload);
  },
  AddScreenSeatTypeGroup(payload) {
    return Api().post(`/api/admin/ms_screen_seat_type_group`, payload);
  },
  EditScreenSeatTypeGroup(payload) {
    return Api().put(`/api/admin/ms_screen_seat_type_group`, payload);
  },
  GetAllScreenSeatTypeGroup(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/ms_screen_seat_type_group${query}`);
  },
  GetScreenSeatTypeGroup(payload) {
    return Api().get(`/api/admin/ms_screen_seat_type_group/${payload.sstg_id}`);
  },
  AddCode(payload) {
    return Api().post(`/api/marketing/referral_code`, payload);
  },
  AddFnbLabel(payload) {
    return Api().post(`/api/admin/ms_fnb_labels`, payload);
  },
  EditLabel(payload) {
    return Api().put(`/api/admin/ms_movie_labels`, payload);
  },
  EditReferralCode(payload) {
    return Api().put(`/api/marketing/referral_code`, payload);
  },
  EditFnbLabel(payload) {
    return Api().put(`/api/admin/ms_fnb_labels`, payload);
  },
  GetSingleLabel(payload) {
    return Api().get(`/api/admin/ms_movie_labels/${payload.label_id}`);
  },
  getReferralCode(payload) {
    return Api().get(`/api/marketing/referral_code/${payload.r_id}`);
  },
  GetSingleFnbLabel(payload) {
    return Api().get(`/api/admin/ms_fnb_labels/${payload.label_id}`);
  },
  updateModuleFavouriteOrder(payload) {
    return Api().put(`/api/admin/update-hot-picks-order`, payload);
  },
  GetDefaultDistributorTax() {
    return Api().get(`/api/admin/default_distributor_tax`);
  },
  UpdateLanguageOrder(payload) {
    return Api().put(`/api/admin/editLanguageOrder`, payload);
  },
  GetMacsSettings() {
    return Api().get(`/api/admin/macs/getAllMacsSettings`);
  },
  // UpdateMacsSettings(payload) {
  //   return Api().post(`/api/admin/macs/updateMacs`, payload);
  // },
  GetAllDistributors(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/ms_distributors${query}`);
  },
  GetMacsOrganisation() {
    return Api().get(`/api/admin/getMacsOrganisation`);
  },
  GetAllScreens(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/getAllScreens${query}`);
  },
  UpdateMacsSettings(payload) {
    return Api().put(`/api/admin/updateMacsSettings`, payload);
  },
  SaveOnDemandSetting(payload) {
    return Api().post(`/api/admin/updateOnDemandSetting`, payload);
  },
  UpdateLabelsOrder(payload) {
    return Api().put(`/api/admin/editLabelsOrder`, payload);
  },
  UpdateFnbLabelsOrder(payload) {
    return Api().put(`/api/admin/editFnbLabelsOrder`, payload);
  },
  UpdateMovieCategoryOrder(payload) {
    return Api().put(`/api/admin/editMovieCategoryOrder`, payload);
  },
  EnableDisableSchedule(payload) {
    return Api().post(
      `/api/admin/disableSchedule/${payload.md_id}/${payload.ss_id}/${payload.type}`
    );
  },
  ExtendSeatReleaseTime(payload) {
    return Api().get(`/api/pos/reset-timer/${payload.reservation_id}`);
  },
  GetCinemaSettings(payload) {
    return Api().get(`/api/pos/cinemasetting/${payload.cinema_id}`);
  },
  SendBookingMail(payload) {
    return Api().post(`/api/pos/booking-email`, payload);
  },
  SendBookingSMS(payload) {
    return Api().post(`/api/pos/booking-sms`, payload);
  },
  getAllAddonsCharges(payload) {
    return Api().get(`/api/admin/get-addons-rate-cards/${payload.cinema_id}`);
  },
  UpdateAddonsCharge(payload) {
    return Api().post(`/api/admin/add-addons-rate-cards`, payload);
  },
  TestPrint(payload) {
    return Api().get(`/api/pos/testprint/${payload.cinema_id}/${payload.type}`);
  },
  GetAllHardwareLocations(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/hardware_locations${qs}`);
  },
  AddHardwareLocation(payload) {
    return Api().post(`/api/admin/hardware_locations`, payload);
  },
  UpdateHardwareLocation(payload) {
    return Api().put(`/api/admin/hardware_locations`, payload);
  },
  getSingleHardwareLocation(payload) {
    return Api().get(`/api/admin/hardware_locations/${payload.hl_id}`);
  },
  getHardwarelocationByCinema(payload) {
    return Api().get(
      `/api/admin/get_pos_hardware_location_by_cinema/${payload.cinema_id}`
    );
  },
  UpdatePosHardwareSettings(payload) {
    return Api().put(`/api/admin/update_pos_hardware_settings`, payload);
  },
  getPosHardwareSettings(payload) {
    return Api().get(
      `/api/admin/get_pos_hardware_settings/${payload.unique_id}`
    );
  },
  GetAllCinema(payload) {
    return Api().post(`/api/pos/getcinemaslist`, payload);
  },
  // onBackupDatabase(options) {
  //   return Api().get(`/api/admin/backup`, options);
  // },
  onRestoreDatabase(payload) {
    return Api().post(`/api/admin/restore`, payload);
  },
  onGuestDetails(payload) {
    return Api().post(`/api/guest-login`, payload);
  },
  getCinemaList(payload) {
    return Api().get(`api/signage/signage-cinema-list`, payload);
  },
  onBackupDatabase(options) {
    // return Api().post('uploadimage',payload)
    let JWT = window.localStorage.getItem("JWT_TOKEN");
    let opts = {
      headers: {
        Authorization: JWT,
        "Access-Control-Allow-Origin": "*",
      },
    };
    if (options) {
      opts = {
        ...opts,
        ...options,
      };
    }

    console.log(opts);
    return new Promise((resolve, reject) => {
      axios
        .get(`${BASEURL}/api/admin/backup-newBb`, opts)
        .then((res) => resolve(res))
        .catch((error) => {
          reject(error);
        });
    });
  },
  AddManualBiilingCategory(payload) {
    return Api().post(`/api/admin/manual_bill/manual_bill_category`, payload);
  },
  UpdateManualBiilingCategory(payload) {
    return Api().put(`/api/admin/manual_bill/manual_bill_category`, payload);
  },
  GetAllManualBiilingCategory(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/manual_bill/manual_bill_category${query}`);
  },
  GetSingleManualBiilingCategory(payload) {
    return Api().get(
      `/api/admin/manual_bill/manual_bill_category/${payload.category_id}`
    );
  },
  AddManualBiilingItem(payload) {
    return Api().post(`/api/admin/manual_bill/manual_bill_items`, payload);
  },
  UpdateManualBiilingItem(payload) {
    return Api().put(`/api/admin/manual_bill/manual_bill_items`, payload);
  },
  GetAllManualBiilingItems(payload) {
    let query = createQueryString(payload);
    return Api().get(`/api/admin/manual_bill/manual_bill_items${query}`);
  },
  GetSingleManualBiilingItem(payload) {
    return Api().get(
      `/api/admin/manual_bill/manual_bill_item/${payload.item_id}`
    );
  },
  GetTaxSettings() {
    return Api().get(`/api/admin/tax_settings`);
  },
  GetAllCinemaScreenList() {
    return Api().get(`/api/admin/cinema_screen_list`);
  },
  AddMerchandiseSizes(payload) {
    return Api().post(`/api/admin/add/merchandise_sizes`, payload);
  },
  UpdateMerchandiseSizes(payload) {
    return Api().post(`/api/admin/update/merchandise_sizes`, payload);
  },
  GetAllMerchandiseSizes(payload) {
    return Api().post(`/api/admin/get/merchandise_sizes`, payload);
  },
  GetSingleMerchandiseSizes(payload) {
    return Api().get(`/api/admin/getMasterDetails/sizes/${payload.size_id}`);
  },
  GetMerchandiseDetails(payload) {
    return Api().get(
      `/api/admin/merchandise_details/${payload.merchandise_id}`
    );
  },
  getFnbStations(payload) {
    return Api().get(`/api/admin/getFnbStations`, { params: payload });
  },
  addUpdateFnbStation(payload) {
    return Api().post(`/api/admin/addUpdateFnbStation`, payload);
  },
  GetAllMerchandises(payload) {
    return Api().post(`/api/admin/get/merchandises`, payload);
  },
  GetAllMerchandises(payload) {
    return Api().post(`/api/admin/get/merchandises`, payload);
  },
  AddMerchandise(payload) {
    return Api().post(`/api/admin/add_merchandise`, payload);
  },
  UpdateMerchandise(payload) {
    return Api().post(
      `/api/admin/update_merchandise/${payload.merchandise_id}`,
      payload
    );
  },
  GetAllVariantsStock(payload) {
    return Api().post(`/api/admin/get_all_variants_stock`, payload);
  },
  UpdateMerchandiseStock(payload) {
    return Api().post(`/api/admin/update_variants_stock`, payload);
  },
  AddMerchandiseCategory(payload) {
    return Api().post(`/api/admin/add/merchandise_categories`, payload);
  },
  UpdateMerchandiseCategory(payload) {
    return Api().post(`/api/admin/update/merchandise_categories`, payload);
  },
  GetAllMerchandiseCategory(payload) {
    return Api().post(`/api/admin/get/merchandise_categories`, payload);
  },
  GetSingleMerchandiseCategory(payload) {
    return Api().get(
      `/api/admin/getMasterDetails/categories/${payload.m_cat_id}`
    );
  },
  AddMerchandiseTag(payload) {
    return Api().post(`/api/admin/add/merchandise_tags`, payload);
  },
  UpdateMerchandiseTag(payload) {
    return Api().post(`/api/admin/update/merchandise_tags`, payload);
  },
  GetAllMerchandiseTags(payload) {
    return Api().post(`/api/admin/get/merchandise_tags`, payload);
  },
  GetSingleMerchandiseTag(payload) {
    return Api().get(`/api/admin/getMasterDetails/tags/${payload.m_tag_id}`);
  },
  AddMerchandiseColor(payload) {
    return Api().post(`/api/admin/add/merchandise_colors`, payload);
  },
  UpdateMerchandiseColor(payload) {
    return Api().post(`/api/admin/update/merchandise_colors`, payload);
  },
  GetAllMerchandiseColor(payload) {
    return Api().post(`/api/admin/get/merchandise_colors`, payload);
  },
  GetSingleMerchandiseColor(payload) {
    return Api().get(`/api/admin/getMasterDetails/colors/${payload.color_id}`);
  },
  GetMerchandiseTransactions(payload) {
    return Api().post(`/api/admin/get-merchandise-transactions`, payload);
  },
  GetMerchandiseCurrentStock(payload) {
    return Api().post(`/api/admin/get-merchandise-current-stock`, payload);
  },
  UploadMerchandiseStock(payload) {
    return Api().post(`/api/admin/upload-merchandise-stock`, payload);
  },

  updateGenreOrder(payload) {
    return Api().post(`api/admin/updateGenreOrder`, payload);
  },
  checkGOrderExists(g_order) {
    return Api().post(`/api/admin/checkValidationGenreOrder`, { g_order });
  },

  getStateDataWithCountry(payload) {
    return Api().post(`/api/admin/getStateDataWithCountry`, payload);
  },

  getCityDataWithCountryAndState(payload) {
    return Api().post(`/api/admin/getCityDataWithCountryAndState`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/MasterService.js